import { combineReducers } from "redux";

import totalservices from "../features/admin/dashboard/totalservices/Slice";

import common from "../features/admin/common/Slice";

const dashboard = combineReducers({
  totalservices,
  common
});

export default dashboard;
